import { IdentityProvider } from '@/types/Activity'

export interface IdentityProviderButton {
  label: string
  url: string
}

export const identityProviderButtonMap = (
  identityProvider?: IdentityProvider,
): IdentityProviderButton | undefined => {
  switch (identityProvider) {
    case IdentityProvider.Credas:
      return {
        label: 'Access Credas',
        url: 'https://portal.credas.com/auth-v2/login',
      }
    case IdentityProvider.Entrust:
      return {
        label: 'Access Entrust',
        url: 'https://dashboard.onfido.com/users/sign_in',
      }
    default:
      return undefined
  }
}
